import { motion } from "framer-motion";
import { Beer, Glasses, HardHat } from "lucide-react";
import background from "../../../assets/image/oktoberfest.png";
import confettiAnimation from "../../../assets/lottie/coriandoli.json";
import Lottie from "lottie-react";

const listItems = [
    { icon: Beer, label: "Bicchieri" },
    { icon: HardHat, label: "Cappelli" },
    { icon: Glasses, label: "Occhiali" },
];

const containerVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: {
        opacity: 1,
        scale: 1,
        transition: {
            type: "spring",
            stiffness: 120,
            damping: 15,
            delayChildren: 0.3,
            staggerChildren: 0.15
        }
    },
    exit: { opacity: 0, scale: 0.9 }
};

const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
};

const OktoberfestModal = ({ onClose }) => {
    return (
        <motion.div
            className="fixed inset-0 bg-black/70 flex items-center justify-center z-[100]"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            {/* Confetti */}
            <Lottie
                animationData={confettiAnimation}
                loop={false}
                className="absolute inset-0 w-full h-full pointer-events-none z-[]"
            />

            <motion.div
                className="relative bg-surface rounded-2xl overflow-hidden shadow-2xl max-w-md w-[90%] border-4 border-primary z-50"
                variants={containerVariants}
                initial="hidden"
                animate="visible"
                exit="exit"
            >
                {/* Background immagine */}
                <div className="relative h-56 w-full overflow-hidden">
                    <motion.img
                        src={background}
                        alt="Oktoberfest"
                        className="absolute inset-0 h-full w-full object-cover"
                        initial={{ scale: 1.2 }}
                        animate={{ scale: 1 }}
                        transition={{ duration: 1.2, ease: "easeOut" }}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent flex flex-col justify-end p-5">
                        <motion.h2
                            className="text-white text-3xl font-title font-extrabold drop-shadow-lg tracking-wide"
                            variants={itemVariants}
                        >
                            🍻 OKTOBERFEST {new Date().getFullYear()} 🍻
                        </motion.h2>
                    </div>
                </div>

                {/* Contenuto */}
                <div className="p-6 space-y-6 text-center text-secondary">
                    <motion.p
                        className="text-base font-medium leading-relaxed"
                        variants={itemVariants}
                    >
                        Ordina le nostre{" "}
                        <span className="text-primary font-semibold">birre speciali</span> <br />
                        e ricevi gadget esclusivi!
                    </motion.p>

                    {/* Lista gadget con wiggle */}
                    <motion.ul
                        className="space-y-3 text-sm text-muted flex flex-col items-center"
                        initial="hidden"
                        animate="visible"
                        variants={containerVariants}
                    >
                        {listItems.map((item, idx) => {
                            const Icon = item.icon;
                            return (
                                <motion.li
                                    key={idx}
                                    className="flex items-center gap-3 text-lg font-medium cursor-pointer"
                                    whileHover={{
                                        scale: 1.1,
                                        rotate: [0, 8, -8, 0] // wiggle
                                    }}
                                    transition={{
                                        duration: 0.5,
                                        ease: "easeInOut",
                                        type: "tween"
                                    }}
                                    variants={itemVariants}
                                >
                                    <Icon className="w-6 h-6 text-primary drop-shadow-md" />
                                    {item.label}
                                </motion.li>
                            );
                        })}
                    </motion.ul>

                    {/* Bottone heartbeat */}
                    <motion.button
                        onClick={onClose}
                        className="bg-primary text-black px-6 py-2 rounded-full font-semibold shadow-lg"
                        variants={itemVariants}
                        animate={{ scale: [1, 1.05, 1] }} // heartbeat
                        transition={{
                            repeat: Infinity,
                            duration: 1.5,
                            ease: "easeInOut",
                            type: "tween" // ✅ invece di spring
                        }}
                        whileHover={{ scale: 1.15 }}
                    >
                        Chiudi
                    </motion.button>
                </div>
            </motion.div>
        </motion.div>
    );
};

export default OktoberfestModal;
